module.exports = __webpack_public_path__ + "img/ecommerce-2140604_1280.3265382e.jpg";